module.exports = __webpack_public_path__ + "static/media/swirepay-logo.4d3b24c7.svg";